import { AdCampaignMediaTypeEnum, useMediaPromoUploadMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { UsePromoUploadResultType, UsePromoUploadType } from './types';

const usePromoUpload = (): UsePromoUploadType => {
  const [promoUploadMutation, promoUploadMutationResult] = useMediaPromoUploadMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const uploadPromo = async (file: File, mediaType?: AdCampaignMediaTypeEnum) =>
    promoUploadMutation({
      variables: {
        input: { file, mediaType },
      },
    });

  const result: UsePromoUploadResultType = {
    error: promoUploadMutationResult.error,
    loading: promoUploadMutationResult.loading,
    called: promoUploadMutationResult.called,
  };

  return {
    result,
    uploadPromo,
  };
};

export default usePromoUpload;
